// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "css/" + ({"4098": "made-category-reviews","6565": "price-slider","7413": "made-category-carousel","7587": "made-reorder-modal",}[chunkId] || chunkId) + "-" + {"1626": "771836d41a4686e1","4098": "1a65d120fa52d074","4513": "5e72cb52842dc4fc","6565": "eeee93328bcf4dbb","7413": "f978e4fa2715b721","7587": "21d97f258501a884",}[chunkId] + ".chunk.css"
}